import { render, staticRenderFns } from "./ExcelMapper.vue?vue&type=template&id=13df17d0&scoped=true"
import script from "./ExcelMapper.vue?vue&type=script&lang=ts"
export * from "./ExcelMapper.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13df17d0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13df17d0')) {
      api.createRecord('13df17d0', component.options)
    } else {
      api.reload('13df17d0', component.options)
    }
    module.hot.accept("./ExcelMapper.vue?vue&type=template&id=13df17d0&scoped=true", function () {
      api.rerender('13df17d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/excel-mapper/ExcelMapper.vue"
export default component.exports